import AnalogyWithImages from "../components/LogicalReasoning/Analogy";
import CodingDecoding from "../components/LogicalReasoning/CodingDecoding";
import CountShapes from "../components/LogicalReasoning/CountShapes";
import Grouping from "../components/LogicalReasoning/Grouping";
import MeasuringUnit from "../components/LogicalReasoning/MeasuringUnit";
import OddOneOut from "../components/LogicalReasoning/OddOneOut";
import Patterns from "../components/LogicalReasoning/Patterns";
import RankingTest from "../components/LogicalReasoning/RankingTest";
import SpatialUnderstanding from "../components/LogicalReasoning/SpatialUnderstanding";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

const topics: MenuItem[] = [
    { url: "/logical-reasoning/patterns", title: "Patterns", component: Patterns },
    //{ url: "/logical-reasoning/classone/measuring-units", title: "Measuring Units", component: MeasuringUnit },
    { url: "/logical-reasoning/geometrical-shapes", title: "Geometrical Shapes", component: CountShapes },
    { url: "/logical-reasoning/odd-one-out", title: "Odd One Out", component: OddOneOut },
   // { url: "/logical-reasoning/classone/spatial-understanding", title: "Spatial Understanding", component: SpatialUnderstanding },
    { url: "/logical-reasoning/grouping", title: "Grouping", component: Grouping },
    { url: "/logical-reasoning/analogy", title: "Analogy", component: AnalogyWithImages },
    { url: "/logical-reasoning/ranking-test", title: "Ranking Test", component: RankingTest },
    { url: "/logical-reasoning/coding-decoding", title: "Coding-Decoding", component: CodingDecoding },
    // { url: "/logical-reasoning/classtwo/symmetry", title: "Symmetry" },
    // { url: "/logical-reasoning/classtwo/symmetry", title: "Embedded Figures" },
    // { url: "/logical-reasoning/classtwo/symmetry", title: "Paper Folding and Cutting" },
    // { url: "/logical-reasoning/classtwo/symmetry", title: "Situation Reaction" },
    // { url: "/logical-reasoning/classtwo/symmetry", title: "Mirror and Water Images" },
];

export default topics;